var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewProjectPopupCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#new_project_popup_cancel_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.167 4.273-.94-.94L8.5 7.06 4.774 3.333l-.94.94L7.56 8l-3.726 3.727.94.94L8.5 8.94l3.727 3.727.94-.94L9.44 8z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "new_project_popup_cancel_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h16v16H.5z"
})))));
export default SvgNewProjectPopupCancel;